import { useEffect, useState } from 'react';

export type WalletInfo = { configured: boolean; address?: string; network: string; standard: string; depositsEnabled: boolean;
  deposits?: {txId:string;logIndex:number;amountMicro:string;status:string;createdAt:string}[] };
function usdt(value:string) {
  const amount=BigInt(value), decimals=(amount%1000000n).toString().padStart(6,'0').replace(/0+$/,'');
  return (amount/1000000n).toLocaleString('ru-RU')+(decimals?','+decimals:'');
}
export function WalletPanel({ load }: { load: () => Promise<WalletInfo> }) {
  const [wallet, setWallet] = useState<WalletInfo | null>(null);
  const [error, setError] = useState(false);
  const [copied, setCopied] = useState(false);
  useEffect(() => {
    let mounted = true;
    let pending = false;
    const refresh = async () => {
      if (pending || document.hidden) return;
      pending = true;
      try { const data = await load(); if (mounted) { setWallet(data); setError(false); } }
      catch { if (mounted) setError(true); }
      finally { pending = false; }
    };
    void refresh();
    const timer = window.setInterval(() => void refresh(), 15000);
    const onVisible = () => { if (!document.hidden) void refresh(); };
    document.addEventListener('visibilitychange', onVisible);
    return () => { mounted = false; window.clearInterval(timer); document.removeEventListener('visibilitychange', onVisible); };
  }, [load]);
  return <section aria-label="Кошелёк USDT" style={{ padding: 20, border: '1px solid #64748b55', borderRadius: 12, marginTop: 24 }}>
    <h2 style={{ fontWeight: 600 }}>Кошелёк USDT · TRON (TRC-20)</h2>
    {error ? <p role="alert">Не удалось получить адрес. Обновите страницу.</p> : !wallet ? <p>Загрузка адреса…</p> : !wallet.configured ? <p>Кошелёк ещё не настроен.</p> : <>
      <p style={{ marginTop: 12 }}>Ваш постоянный адрес:</p>
      <code style={{ display: 'block', overflowWrap: 'anywhere', margin: '8px 0' }}>{wallet.address}</code>
      <button type="button" onClick={async () => {
        try { await navigator.clipboard.writeText(wallet.address!); setCopied(true); }
        catch { setCopied(false); }
      }}>Скопировать адрес</button>
      {copied && <span role="status"> Скопировано</span>}
      {!wallet.depositsEnabled && <p role="status" style={{ marginTop: 12, fontWeight: 600 }}>Пополнение пока не активировано. Не отправляйте средства до подключения и проверки зачислений.</p>}
      {wallet.depositsEnabled && <p style={{ marginTop: 12 }}>Зачисление происходит после подтверждения перевода сетью TRON.</p>}
      <p style={{ marginTop: 8 }}>Только USDT в сети TRON (TRC-20). Баланс кабинета учитывается отдельно от баланса адреса в сети.</p>
      {!!wallet.deposits?.length && <div style={{ marginTop:16 }}><h3>Последние пополнения (до 20)</h3><ul>
        {wallet.deposits.map(d=><li key={`${d.txId}:${d.logIndex}`} style={{ marginTop:8 }}>
          {usdt(d.amountMicro)} USDT · {d.status==='credited'?'Зачислено':'Проверяется поддержкой'} · {new Date(d.createdAt).toLocaleString('ru-RU')}
          {' '}<a href={`https://tronscan.org/#/transaction/${d.txId}`} target="_blank" rel="noreferrer">Перевод ↗</a>
        </li>)}
      </ul></div>}
    </>}
  </section>;
}
